// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"915285eb","423":"cfc41eb3","462":"b5e3c541","564":"afe1db09","720":"cafe4ad8","915":"6dcf979f","917":"a64a9dd7"}[chunkId] + ".chunk.js";
};